/* eslint-disable react/jsx-no-useless-fragment */
import AuthGate from '@pages/AuthGate/screens';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

type Props = { children: React.ReactNode };

export default function AutoLoginGuard({ children }: Readonly<Props>) {
  const { isAuthenticated, isLoading, signinRedirect, signinSilent, user } =
    useAuth();

  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      localStorage.getItem('LOGOUT_INTENT') !== 'true'
    ) {
      signinRedirect();
    }
  }, [isLoading, isAuthenticated, signinRedirect]);

  useEffect(() => {
    if (isAuthenticated && user?.expired) {
      signinSilent().catch(() => signinRedirect());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.expired]);

  if (isLoading) return null;
  if (!isAuthenticated && localStorage.getItem('LOGOUT_INTENT') === 'true')
    return <AuthGate />;
  if (!isAuthenticated) return null;
  return <>{children}</>;
}
